module.exports = __webpack_public_path__ + "img/full6-min.ce3d87a8.png";